export default __webpack_public_path__ + "static/media/ClockPRO.5d62e1c5.jpg";